import type { Tier } from "../schema/common.js";
export const HUNT_MILESTONES = [
  { kills: 1, itemId: "itm.chest_bronze" },
  { kills: 3, itemId: "itm.chest_silver" },
  { kills: 6, itemId: "itm.chest_gold" },
] as const;
export const EQUIPMENT_CHEST_ODDS: Record<string, { tier: Tier; pct: number }[]> = {
  "itm.chest_bronze": [
    { tier: "D", pct: 55 },
    { tier: "C", pct: 30 },
    { tier: "B", pct: 12 },
    { tier: "A", pct: 3 },
  ],
  "itm.chest_silver": [
    { tier: "C", pct: 50 },
    { tier: "B", pct: 35 },
    { tier: "A", pct: 13 },
    { tier: "S", pct: 2 },
  ],
  "itm.chest_gold": [
    { tier: "B", pct: 60 },
    { tier: "A", pct: 35 },
    { tier: "S", pct: 5 },
  ],
};
export const EQUIPMENT_DRAW_PRICE = 75;
export const EQUIPMENT_DRAWS_PER_DAY = 5;
